import { createHelpers } from 'vuex-map-fields';

const { getInboxStateField, updateInboxStateField } = createHelpers({
	getterType: `getInboxStateField`,
	mutationType: `updateInboxStateField`,
});


const state = {

	pagination : {
		limit : 50,
		limitstart : 0,
		pagesCurrent : 1,
		pagesStart : 1,
		pagesStop : 0,
		pagesTotal :1,
		total : 0
	},
	list: [],
	doc_type: 0,
	filter: [],

	all_filter : [],

	send_list : {
		limit_start : 0,
		direction : "DESC",
		ordering  : "m.added"
	}

};


const getters = {
	getListState(state) {
		return state.list;
	},

	getFilterState(state) {
		return state.filter;
	},

	getInboxStateField,

};
// actions
const actions = {

	LOAD_PAGINATION({commit},data) {
		state.pagination = {...state.pagination,...data};
	},

	LOAD_STATES({commit},data) {

	    let uiid = "";
	    if(data.hasOwnProperty("uiid")) {
            uiid = data.uiid;
        }

		state.list = {...state.list,...data.list};
		state.filter = {...state.filter,...data.filter};
		state.all_filter = {...state.all_filter,...data.all_filter};
		state.uiid = uiid;

		EventBus.$emit('products_reload_items', state);
	},


	LOAD_STATE({commit}) {
		/* axios.get('index.php?option=com_imc_docs&task=api.getUser').then(({data}) => {
			 if(data.status === "operation_success") {
				 state.user = {...state.user,...data.message};
				 EventBus.$emit('user_added', state.user);
			 }
		 })*/
	},

};


// mutations
const mutations = {
	updateInboxStateField,

	/* addUser(state,data) {
		 state.user = data;
		 EventBus.$emit('user_added', data);
		 state.module.is_load = true;
	 },

	 setUserField(state,data) {
		 state.user = {...state.user,...data};
	 },*/


};


export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
}
